<template>
  <div class="block page9 f-r f-c">
    <PageHeader
      :title="moduleData['3_9_1_1']"
      :sub-title="moduleData['3_9_1_1_en']"
      :page-logo="reportCustomization.pageLogo"
    />
    <PageTips :page-num="pageNum" />
    <div class="page9-body f-r j-b">
      <div class="page9-body-left f-r j-b f-w">
        <div class="page9-border-item box1 f-r j-b" style="height: 200px">
          <div class="group_26 flex-col justify-between">
            <div class="box_3 flex-col ditie"></div>
            <span class="text_3">{{ PAGE_TEXT[commonLang].subwayStation }}</span>
          </div>
          <div class="text-wrapper_2">
            <span class="text_4">
<!--              {{ moduleData["3_9_2_1"].subway_station.val }}-->
              {{ poiData?.traffic?.subwayCount || '--' }}
            </span>
            <span class="text_5"></span>
            <span class="text_14">
              {{ moduleData["3_9_2_1"].subway_station.company }}
            </span>
          </div>
        </div>
        <div class="page9-border-item box1 f-r j-b" style="height: 200px">
          <div class="group_26 flex-col justify-between">
            <div class="box_3 flex-col bus"></div>
            <span class="text_3">{{ PAGE_TEXT[commonLang].busStop }}</span>
          </div>
          <div class="text-wrapper_2">
            <span class="text_4">
<!--              {{ moduleData["3_9_2_1"].bus_stop.val }}-->
              {{ poiData?.traffic?.busCount || '--' }}
            </span>
            <span class="text_5"></span>
            <span class="text_14">
              {{ moduleData["3_9_2_1"].bus_stop.company }}
            </span>
          </div>
        </div>
        <div class="page9-border-item box2">
          <div class="group_4 buxing"></div>
          <div class="image-text_21">
            <div class="text_9">
              {{ poiData?.traffic?.walkToSubwayTime || '--' }}
              {{ moduleData["3_9_2_1"].subway_station_walk_time.company }}
            </div>
            <div class="text_10">
              {{ moduleData["3_9_2_1"].subway_station_walk_time.tip }}
            </div>
          </div>
          <div class="group_7 ditie_small" />
        </div>
        <div class="page9-border-item box2">
          <div class="group_4 buxing"></div>
          <div class="image-text_21">
            <div class="text_9">
              {{ poiData?.traffic?.walkToBusTime || '--' }}
              {{ moduleData["3_9_2_1"].bus_stop_walk_time.company }}
            </div>
            <div class="text_10">
              {{ moduleData["3_9_2_1"].bus_stop_walk_time.tip }}
            </div>
          </div>
          <div class="group_7 bus_small" />
        </div>
        <div class="page9-border-item box2">
          <div class="group_4 car"></div>
          <div class="image-text_21">
            <div class="text_9">
              {{ poiData?.traffic?.driveToRailwayTime || '--' }}
              {{ moduleData["3_9_2_1"].drive_station_time.company }}
            </div>
            <div class="text_10">
              {{ moduleData["3_9_2_1"].drive_station_time.tip }}
            </div>
          </div>
          <div class="group_7 huochezhan2" />
        </div>
        <div class="page9-border-item box2">
          <div class="group_4 car"></div>
          <div class="image-text_21">
            <div class="text_9">
              {{ poiData?.traffic?.driveToAirportTime || '--' }}
              {{ moduleData["3_9_2_1"].drive_airport_time.company }}
            </div>
            <div class="text_10">
              {{ moduleData["3_9_2_1"].drive_airport_time.tip }}
            </div>
          </div>
          <div class="group_7 feiji" />
        </div>
        <div class="page9-left-tips">
          <div class="page9-left-tips-title">{{ PAGE_TEXT[commonLang].analysisInterpretation }}</div>
          <p v-for="(item,index) in moduleData['3_9_3_1'][0]" :key="index">{{item}}</p>
        </div>
      </div>
      <div class="page9-body-right">
        <div class="page9-body-right f-c">
          <div class="page3-map" id="page3Map"></div>
          <div class="page3-map-legend f-r a-c">
            <div class="page3-map-legend-item f-r a-c">
              <div class="page3-map-legend-icon icon1"></div>
              {{ PAGE_TEXT[commonLang].airport }}
            </div>
            <div class="page3-map-legend-item f-r a-c">
              <div class="page3-map-legend-icon icon2"></div>
              {{ PAGE_TEXT[commonLang].trainStation }}
            </div>
            <div class="page3-map-legend-item f-r a-c">
              <div class="page3-map-legend-icon icon3"></div>
              {{ PAGE_TEXT[commonLang].passengerStation }}
            </div>
            <div class="page3-map-legend-item f-r a-c">
              <div class="page3-map-legend-point point1"></div>
              {{ PAGE_TEXT[commonLang].busStop }}
            </div>
            <div class="page3-map-legend-item f-r a-c">
              <div class="page3-map-legend-point point2"></div>
              {{ PAGE_TEXT[commonLang].subwayStation }}
            </div>
          </div>
          <div v-if="reportCustomization.showDataSource" class="page3-map-tips">
            {{ PAGE_TEXT[commonLang].dataSource }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import PageHeader from "./components/PageHeader";
import PageTips from "./components/PageTips";
import AMapLoader from "@amap/amap-jsapi-loader";
import { shallowRef } from "@vue/reactivity";
import { onMounted } from "vue";
import { mapAddCircle, addMapCenter, mapAddPolygonV2 } from "@/utils/pdf";
import { useStore } from "vuex";
import { AMAP_KEY } from '@/constants/common'

import { getMapDelayByMarkerCount } from '@/utils'
import {
  drawMapKeepAlive,
} from '@/api/apiv2'

const props = defineProps({
  pageNum: String,
  cityInfo: {
    type: Object,
    default: () => {
      return {};
    },
  },
  catData: {
    type: Array,
    default: () => {
      return [];
    },
  },
  moduleData: {
    type: Object,
    default: () => {},
  },
  // poi改造后数据
  poiData: {
    type: Object,
    default: () => {},
  },
  reportCustomization: {
    type: Object,
    default: () => {},
  },
  commonLang: {
    type: String,
    default: 'zh'
  }
});

const PAGE_TEXT = {
  'zh': {
    subwayStation: '地铁站',
    busStop: '公交站',
    analysisInterpretation: '分析解读',
    airport: '机场',
    trainStation: '火车站',
    passengerStation: '客运站',
    dataSource: '数据来源：位置厂商数据'
  },
  'en': {
    subwayStation: 'Subway Station',
    busStop: 'Bus Stop',
    analysisInterpretation: 'Analysis Interpretation',
    airport: 'Airport',
    trainStation: 'Train Station',
    passengerStation: 'Passenger Station',
    dataSource: 'Data Source: Location vendor data'
  }
};

const store = useStore();
    let map = shallowRef(null);
    const image = {
      P050101: require("@/assets/机场.png"),
      P050201: require("@/assets/火车站.png"),
      P050401: require("@/assets/高铁站.png"), // 客运站
    };
    const addMaker = (amap, map, newData) => {
      let markerList = [];
      newData.forEach((el) => {
        el.poi.forEach((v) => {
          if (el.bhProType === "P050601") {
            // 公交站
            let marker = new amap.Marker({
              position: new amap.LngLat(
                v.location.split(",")[0],
                v.location.split(",")[1]
              ),
              content: `
                <div style="width: 12px;height: 12px; border-radius: 50%;background: #1644FF;"></div>
              `,
            });
            markerList.push(marker);
          } else if (el.bhProType === "P050301") {
            // 地铁站
            let marker = new amap.Marker({
              position: new amap.LngLat(
                v.location.split(",")[0],
                v.location.split(",")[1]
              ),
              content: `
                <div style="width: 12px;height: 12px; border-radius: 50%;background: #FF8116;"></div>
              `,
            });
            markerList.push(marker);
          } else {
            let icon = new amap.Icon({
              size: new amap.Size(20, 21), // 图标尺寸
              image: image[el.bhProType], // Icon的图像
              imageSize: new amap.Size(20, 21), // 根据所设置的大小拉伸或压缩图片
            });
            let marker = new amap.Marker({
              position: new amap.LngLat(
                v.location.split(",")[0],
                v.location.split(",")[1]
              ),
              icon: icon, // 添加 Icon 实例 ，icon也可以是url链接
            });
            markerList.push(marker);
          }
        });
      });
      map.add(markerList);
    };
    onMounted(() => {
      AMapLoader.load({
        key: AMAP_KEY, // 申请好的Web端开发者Key，首次调用 load 时必填
        version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        plugins: [""], // 需要使用的的插件列表，如比例尺'AMap.Scale'等
      })
        .then((AMap) => {
          map = new AMap.Map("page3Map", {
            WebGLParams: {
              preserveDrawingBuffer: true,
            },
            dragEnable: false,
            zoomEnable: false,
            zoom: store.getters.mapZoom, //初始化地图级别
            center: props.cityInfo.location.split(","), //初始化地图中心点位置
            // languageCode: 'en',
          });
          addMaker(
            AMap,
            map,
            props.catData.filter((v) => v)
          );

          if (props.cityInfo.is_polygon) {
            mapAddPolygonV2(props.cityInfo.polygon || '', map)
          } else {
            mapAddCircle(props.cityInfo, map);
          }
          addMapCenter(AMap, map, props.cityInfo.location)

          // 等待地图渲染
          const totalCount = props.catData.reduce((a, b) => a + (b?.pois?.length || 0), 0)
          const delay = getMapDelayByMarkerCount(totalCount)
          drawMapKeepAlive(delay).catch((e) => {})

          map.setFitView();
        })
        .catch((e) => {
          console.log(e);
        });
    });
</script>

<style lang="less" scoped>
.page9 {
  position: relative;
  background: #ffffff;
  padding: 26px 60px 32px 0;
  .feiji {
    background-image: url("~@/assets/plane.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
  .ditie {
    background-image: url("~@/assets/subway-1.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
  .ditie_small {
    background-image: url("~@/assets/subway-2.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
  .buxing {
    background-image: url("~@/assets/walk.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
  .bus {
    background-image: url("~@/assets/bus-2.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
  .bus_small {
    background-image: url("~@/assets/bus-1.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
  .car {
    background-image: url("~@/assets/car.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
  .huochezhan2 {
    background-image: url("~@/assets/train.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
  .page9-body {
    flex-grow: 1;
    padding: 67px 20px 0 61px;
    .page9-body-left {
      width: 900px;
      .page9-border-item {
        margin-bottom: 0;
        width: 420px;
        border-radius: 16px;
        border: 2px solid #ff8c00;

        &.box1 {
          margin-bottom: -10px;
          display: flex;
          align-items: center;
          justify-content: space-around;

          .group_26 {
            width: 100px;
            height: 145px;

            .box_3 {
              width: 100px;
              height: 100px;
              background-size: 100% 100%;
            }
            .text_3 {
              width: 90px;
              height: 42px;
              overflow-wrap: break-word;
              color: rgba(51, 51, 51, 1);
              font-size: 30px;
              text-align: left;
              white-space: nowrap;
              line-height: 42px;
              margin: 3px 0 0 10px;
            }
          }
          .text-wrapper_2 {
            height: 90px;
            overflow-wrap: break-word;
            font-size: 0;
            text-align: left;
            white-space: nowrap;
            line-height: 90px;

            .text_4 {
              width: 107px;
              height: 90px;
              overflow-wrap: break-word;
              color: rgba(51, 51, 51, 1);
              font-size: 64px;
              text-align: left;
              white-space: nowrap;
              line-height: 90px;
            }
            .text_5 {
              width: 107px;
              height: 90px;
              overflow-wrap: break-word;
              color: rgba(51, 51, 51, 1);
              font-size: 30px;
              text-align: left;
              line-height: 90px;
            }
            .text_14 {
              width: 107px;
              height: 90px;
              overflow-wrap: break-word;
              color: rgba(102, 102, 102, 1);
              font-size: 20px;
              text-align: left;
              line-height: 90px;
            }
          }
        }

        &.box2 {
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: -10px;
          height: 160px;

          .group_4 {
            margin-right: 12px;
            width: 67px;
            height: 67px;
          }
          .image-text_21 {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: space-between;

            .text_9 {
              line-height: 33px;
              overflow-wrap: break-word;
              color: rgba(51, 51, 51, 1);
              font-size: 24px;
              text-align: center;
              white-space: nowrap;
            }

            .text_10 {
              margin-top: 12px;
              padding-top: 12px;
              width: max-content;
              line-height: 33px;
              overflow-wrap: break-word;
              color: rgba(102, 102, 102, 1);
              font-size: 24px;
              text-align: center;
              white-space: nowrap;
              border-top: 2px dashed #b6b5b5;
            }
          }
          .group_7 {
            margin-left: 12px;
            width: 67px;
            height: 67px;
          }
        }
      }
      .page9-left-tips-title{
        margin-top: 39px;
        margin-bottom: 16px;
        color:#111F2C;
        font-size:24px;
        font-weight:700;
      }
      .page9-left-tips{
         margin-top: -20px;
        p {
          font-size:20px;
          color:#111F2C;
        }
        p + p {
          padding-top: 5px;
        }
      }
    }
    .page9-body-right {
      width: 853px;
      .page3-map {
        width: 100%;
        height: 760px;
      }
      .page3-map-legend {
        flex-grow: 1;
        padding: 23px 0 23px 46px;
        .page3-map-legend-item {
          font-size: 20px;
          font-weight: 400;
          color: #333333;
          line-height: 28px;
          margin-right: 76px;
        }
        .page3-map-legend-item:last-child {
          margin-right: 0;
        }
        .page3-map-legend-icon {
          width: 22px;
          min-width: 22px;
          height: 22px;
          background-size: 100% 100%;
          background-repeat: no-repeat;
          margin-right: 12px;
        }
        .icon1 {
          background-image: url("~@/assets/机场.png");
        }
        .icon2 {
          background-image: url("~@/assets/火车站.png");
        }
        .icon3 {
          background-image: url("~@/assets/高铁站.png");
        }
        .page3-map-legend-point {
          width: 22px;
          min-width: 22px;
          height: 22px;
          margin-right: 12px;
          border-radius: 50%;
        }
        .point1 {
          background-color: #1644ff;
        }
        .point2 {
          background-color: #ff8116;
        }
      }
      .page3-map-tips {
        flex-shrink: 0;
        text-align: right;
        height: 28px;
        font-size: 20px;
        font-weight: 400;
        color: #9a9a9a;
        line-height: 28px;
      }
    }
  }
}
</style>
